import DOMPurify from "dompurify";

export const DEFAULT_AVATAR = "/img/user_avatar.jpg";

export const MESSAGE_TABS = {
  received: "received",
  sent: "sent",
};

export const cleanHtml = (html = "") =>
  DOMPurify.sanitize(html || "Message vide");

export const getUserName = (user, fallback = "Utilisateur") => {
  if (!user) return fallback;

  return [user.prenom, user.nom].filter(Boolean).join(" ") || fallback;
};

export const getUserPhoto = (user) => user?.photoURL || DEFAULT_AVATAR;

export const formatMessageDate = (dateValue) => {
  if (!dateValue) return "Date inconnue";

  const date = new Date(dateValue);

  if (!Number.isFinite(date.getTime())) return "Date inconnue";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatMessageTime = (dateValue) => {
  if (!dateValue) return "";

  const date = new Date(dateValue);

  if (!Number.isFinite(date.getTime())) return "";

  return date.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getMessagePreview = (content = "", maxLength = 140) => {
  const cleanText = String(content || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (cleanText.length <= maxLength) return cleanText || "Message vide";

  return `${cleanText.slice(0, maxLength)}...`;
};

export const normalizeMessagesResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.messages)) return response.messages;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.messages)) return response.data.messages;
  return [];
};